import type { UrqlOperationContext } from 'lib/urqlClient';
import type { OperationContext } from 'urql';
import assert from 'assert';
import React from 'react';
import { usePodApiAccessTokenContext } from 'wrappers/PodApiAccessTokenProvider';

import { useWorkspace, useWorkspaceId } from './useWorkspace';

export function useInternalApiContext(
  additionalContext?: Partial<OperationContext>
) {
  const ctx = usePodApiAccessTokenContext();
  const { workspace } = useWorkspace();
  const workspaceId = useWorkspaceId();
  const { internalApiToken } = ctx;

  assert(workspace, 'Workspace pod info not found');
  const url = workspace.pod.internalApiUrl;

  const context: UrqlOperationContext = React.useMemo(
    () => ({
      url,
      token: internalApiToken,
      workspaceId,
      ...additionalContext,
    }),
    [internalApiToken, url, workspaceId, additionalContext]
  );

  return {
    context,
    token: internalApiToken,
  };
}
